import { z } from "zod";

export const dashboardModuleSettingsSchema = z.object({
  dashboardVisibility: z.boolean(),
});
